import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { TranslationService, SupportedLanguage } from '../services/translation.service';

export const languageGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  console.log('languageGuard: checking language from route', route.params);
  
  const translationService = inject(TranslationService);
  const router = inject(Router);
  
  const langParam = route.params['lang'] as string;
  console.log('languageGuard: extracted language parameter', langParam);
  
  const supportedLanguages: SupportedLanguage[] = ['en', 'he'];
  const isValidLanguage = supportedLanguages.includes(langParam as SupportedLanguage);
  
  if (!langParam || !isValidLanguage) {
    console.log('languageGuard: invalid or missing language, redirecting to default');
    const defaultLang = translationService.getCurrentLanguage();
    const urlSegments = router.url.split('/').filter(s => s && !supportedLanguages.includes(s as SupportedLanguage));
    const newUrl = `/${defaultLang}/${urlSegments.join('/')}`;
    console.log('languageGuard: redirecting to', newUrl);
    router.navigateByUrl(newUrl);
    return false;
  }
  
  const currentLanguage = translationService.getCurrentLanguage();
  console.log('languageGuard: current language', currentLanguage, 'URL language', langParam);
  
  if (currentLanguage !== langParam) {
    console.log('languageGuard: changing language to', langParam);
    await translationService.changeLanguage(langParam as SupportedLanguage);
  }
  
  return true;
};

